// extracted by mini-css-extract-plugin
export var attribution = "_9e-4";
export var authorName = "_9e-5";
export var quote = "_9e-3";
export var testimonial = "_9e-2";
export var trustedBy = "_9e-0";
export var trustedByLabel = "_9e-1";